import React from "react";
import { Checkbox } from "native-base";
import Theme from "../argon-ui/Theme";

const CheckboxBase = (props: any) => {
  const {
    onChange,
    children,
    size = "sm",
    value,
    isDisabled = false,
    checked = false,
  } = props;
  return (
    <Checkbox
      size={size}
      shadow={2}
      value={value}
      onChange={onChange}
      defaultIsChecked={checked}
      isDisabled={isDisabled}
      {...props}
    >
      {children}
    </Checkbox>
  );
};

export default CheckboxBase;
